import classNames from 'classnames'

import { IconInfoCircle } from '@/components/Icons'

type Props = {
  type: 'info'
  size?: 'sm' | 'md' | 'lg'
  withBackground?: boolean
}

const TypeIcon: { [key: string]: React.ComponentType<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>> } = {
  INFO: IconInfoCircle,
}

const Alert: React.FC<React.PropsWithChildren<Props>> = ({ type, children, size = 'lg', withBackground = false }) => {
  const classes = {
    container: classNames('flex items-start gap-2 text-navy-dark rounded-xl', {
      'text-lg p-8': size === 'lg',
      'text-md p-4': size === 'md',
      'text-sm p-4': size === 'sm',
      'bg-purple-bright': !withBackground,
      'bg-purple-light': withBackground && type === 'info',
    }),
    icon: classNames('mt-1.5', {
      'text-purple-base': type === 'info',
      'icon-sm': size === 'lg',
      'icon-xs': size !== 'lg',
    }),
  }
  const Icon = TypeIcon[type.toUpperCase()]

  return (
    <div className={classes.container}>
      <div>
        <Icon className={classes.icon} />
      </div>

      <div>{children}</div>
    </div>
  )
}

export default Alert
